import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { searchActions, cuzkExpandType } from '../../../store/searchStore';
import { translateRestriction } from './propertyCzUtils';
import PropertyCzOwnershipDocument from './propertyCzOwnershipDocument';

import './propertyCz.scss';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class PropertyCzCadastreUnit extends React.Component {
    state = {
        expanded: false
    };

    static propTypes = {
        data: PropTypes.object.isRequired
    };

    static defaultProps = {
        fromSearch: false
    }

    componentDidMount() {
        if (this.props.fromSearch)
            this.setState({ expanded: true})
    }

    render() {
        const data = this.props.data;

        return (
            <>
                <tr>
                    <td>
                        <span onClick={() => this.expandRow(data)} className="link-internal">
                            <Translate id='Report.Detail' />
                        </span>
                    </td>
                    <td>{data.cadastreUnitId}</td>
                    <td>{data.cadastreUnitName}</td>
                    <td>{data.municipalityId}</td>
                    <td>{data.municipalityName}</td>
                    <td>{data.districtId}</td>
                    <td>{data.districtName}</td>
                    {this.props.showRestrictions && <td>{translateRestriction(data.ownershipRestriction, this.props.translate)}</td>}
                </tr>
                <tr style={{ display: this.state.expanded ? "" : "none" }}>
                    <td colSpan={this.props.showRestrictions ? 8 : 7} style={{ paddingLeft: '2em' }}>
                        <p style={{ fontSize: '1.25em', paddingTop: '.5em', fontWeight: 'bold' }}>{!this.props.fromSearch && <Translate id="PropertyCz.Report.OwnershipDeedsOverview" />}</p>
                        <OldStyleTableWithHistory
                            head={() => <thead>
                                <tr>
                                    <th style={{ width: '5em' }} />
                                    <th><Translate id="PropertyCz.Report.OD.OwnershipDeedNo" /></th>
                                    <th><Translate id="PropertyCz.Report.OD.Share" /></th>
                                    <th><Translate id="PropertyCz.Report.OD.NomberOfOwners" /></th>
                                    <th><Translate id="PropertyCz.Report.OD.PropertyRight" /></th>
                                    {data.anyRestrictions && <th><Translate id="PropertyCz.Report.OD.Restriction" /></th>}
                                </tr>
                            </thead>}
                            actualData={data.ownershipDocuments} fixed classNames='old-style-bordered'
                            actualRow={i => <PropertyCzOwnershipDocument key={i.ownershipDocumentId} cadastreUnitId={data.cadastreUnitId} data={i} osId={this.props.osId}
                                showRestrictions={data.anyRestrictions} fromSearch={this.props.fromSearch} />}
                        />
                    </td>
                </tr>
            </>
        );
    }

    expandRow = (data) => {        
        this.setState({ expanded: !this.state.expanded }, () => this.props.cuzkExpand(cuzkExpandType.cadastralUnits, data.cadastreUnitId, null, null, this.state.expanded ))        
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.cuzk } }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertyCzCadastreUnit)));